import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BMEventsType, PageVisibleValueOrigin } from '../types';
var makeFeatureFlags = function makeFeatureFlags(allFeatureFlags, eventTypeFeatureFlags) {
  var featureFlagsForType = [];
  if (allFeatureFlags) {
    featureFlagsForType.push.apply(featureFlagsForType, _toConsumableArray(allFeatureFlags));
  }
  if (eventTypeFeatureFlags) {
    featureFlagsForType.push.apply(featureFlagsForType, _toConsumableArray(eventTypeFeatureFlags));
  }
  return featureFlagsForType;
};
var makeGlobalConfigPerType = function makeGlobalConfigPerType(global, ffClient, allEventsConfig, eventConfig) {
  var _ref, _eventConfig$pageVisi;
  var allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
  var eventConfigCustom = eventConfig && eventConfig.custom;
  var custom = (allEventsConfigCustom || eventConfigCustom) && _objectSpread(_objectSpread({}, allEventsConfigCustom), eventConfigCustom) || undefined;
  var allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
  var eventConfigPlugins = eventConfig && eventConfig.plugins;
  var plugins = (allEventsConfigPlugins || eventConfigPlugins) && [].concat(_toConsumableArray(allEventsConfigPlugins || []), _toConsumableArray(eventConfigPlugins || [])) || undefined;
  var pageVisibleValueOrigin = (_ref = (_eventConfig$pageVisi = eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.pageVisibleValueOrigin) !== null && _eventConfig$pageVisi !== void 0 ? _eventConfig$pageVisi : allEventsConfig === null || allEventsConfig === void 0 ? void 0 : allEventsConfig.pageVisibleValueOrigin) !== null && _ref !== void 0 ? _ref : PageVisibleValueOrigin.documentHidden;
  return Object.freeze(_objectSpread(_objectSpread({}, global), {}, {
    featureFlags: Object.freeze(makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce(function (acc, value) {
      acc[value] = ffClient.getValue(value);
      return acc;
    }, {})),
    custom: custom,
    plugins: plugins,
    histogram: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.histogram,
    pageVisibleValueOrigin: pageVisibleValueOrigin,
    enableBundleEvalTimings: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.enableBundleEvalTimings
  }));
};
export var makeShareableGlobalConfig = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(globalConfig) {
    var _globalConfig$events$, _globalConfig$events$2, _globalConfig$events$3;
    var ffClient, global;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return globalConfig.plugins.featureFlags.client;
        case 2:
          ffClient = _context.sent;
          global = {
            app: globalConfig.info.app,
            product: globalConfig.info.product,
            region: globalConfig.info.region,
            resourceTimings: globalConfig.plugins.resourceTimings,
            bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
            ffClient: ffClient,
            hostname: globalConfig.info.hostname || window.location.hostname,
            ssr: globalConfig.ssr,
            enableReactUFOTracker: globalConfig.enableReactUFOTracker,
            webVitals: {
              enabled: (_globalConfig$events$ = globalConfig.events[BMEventsType.WEB_VITALS]) === null || _globalConfig$events$ === void 0 ? void 0 : _globalConfig$events$.enabled,
              timeout: (_globalConfig$events$2 = globalConfig.events[BMEventsType.WEB_VITALS]) === null || _globalConfig$events$2 === void 0 ? void 0 : _globalConfig$events$2.timeout,
              ttciEnabled: (_globalConfig$events$3 = globalConfig.events[BMEventsType.WEB_VITALS]) === null || _globalConfig$events$3 === void 0 ? void 0 : _globalConfig$events$3.ttciEnabled
            }
          };
          return _context.abrupt("return", _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BMEventsType.PAGE_LOAD, makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[BMEventsType.PAGE_LOAD])), BMEventsType.PAGE_SEGMENT_LOAD, makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[BMEventsType.PAGE_SEGMENT_LOAD])), BMEventsType.INLINE_RESULT, makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[BMEventsType.INLINE_RESULT])), BMEventsType.CUSTOM, makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[BMEventsType.CUSTOM])), BMEventsType.WEB_VITALS, makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[BMEventsType.WEB_VITALS])));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function makeShareableGlobalConfig(_x) {
    return _ref2.apply(this, arguments);
  };
}();